<template>
  <div class="km-prod-list">
    <div class="prod-grid">
      <div v-for="item in cards" :key="item.iid" class="prod-grid-item" @click="() => handleClick(item)">
        <prod-card :title="item.title" :img="item.img" :content="item.content"></prod-card>
      </div>
    </div>
    <div class="prod-empty" v-if="!cards || cards.length === 0">
      <Icon type="ios-cube-outline" size="64" color="#8898AA" />
      <p>暂无产品数据</p>
    </div>
  </div>
</template>

<script>
import ProdCard from './prod-card.vue';
import { GetAllList } from './apis/index';

export default {
  name: 'prod-list',
  components: {
    ProdCard,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      GetAllList().then((res) => {
        console.log(res);
      });
    },
    handleClick(item) {
      this.$router.push(`/prod-detail?id=${item.iid}`);
    },
  },
};
</script>

<style lang="less" scoped>
.km-prod-list {
  width: 100%;
  padding: 24px 0 8px;
}

.prod-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
}

.prod-grid-item {
  animation: fadeInUp 0.5s ease both;

  &:nth-child(1) {
    animation-delay: 0.05s;
  }
  &:nth-child(2) {
    animation-delay: 0.1s;
  }
  &:nth-child(3) {
    animation-delay: 0.15s;
  }
  &:nth-child(4) {
    animation-delay: 0.2s;
  }
  &:nth-child(5) {
    animation-delay: 0.25s;
  }
  &:nth-child(6) {
    animation-delay: 0.3s;
  }
  &:nth-child(7) {
    animation-delay: 0.35s;
  }
  &:nth-child(8) {
    animation-delay: 0.4s;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.prod-empty {
  padding: 60px 20px;
  text-align: center;
  color: var(--text-muted);

  p {
    margin-top: 16px;
    font-size: 15px;
  }
}

/* 响应式 */
@media (max-width: 1024px) {
  .prod-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .km-prod-list {
    padding: 16px 0;
  }
  .prod-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }
}

@media (max-width: 480px) {
  .prod-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
